export const PHONE_DISPLAY = '(011) 4963-1221 INT 437';
export const WHATSAPP_NUMBER = '91131824608';
export const WHATSAPP_DISPLAY = '11 3182-4608';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const EMAIL = 'mitzvatank@jabad.org.ar';
export const LOCATION = 'Buenos Aires, Argentina';

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/MitzvaTankArgentina',
  instagram: 'https://www.instagram.com/mitzvatankargentina',
  youtube: 'https://www.youtube.com/@mitzvatankargentina',
  tiktok: 'https://www.tiktok.com/@mitzvatankargentina',
};
